import { combineReducers } from 'redux';

import { createDuck } from 'helpers/duckTools';
import api from 'store/actions/api';

import adsResultSelector from './adsResultSelector';

const STORE_KEY = 'searchLayout';

export const adsDuck = createDuck(
  'SEARCH_PAGE/ADS',
  {
    result: {
      items: [],
      pagination: undefined,
      meta: undefined,
      searchType: undefined,
      exactAdsCount: undefined,
    },
    error: null,
    isLoading: false,
    isLoaded: false,
  },
  {
    loaders: {
      loadAds: {
        fetch: api.getAdsByType,
        resultSelector: adsResultSelector,
      },
    },
  },
);

export const uiDuck = createDuck('SEARCH_PAGE/UI', {
  isModalFiltersActive: false,
  isSortTouched: false,
});

export const paramsDuck = createDuck('SEARCH_PAGE/PARAMS', {
  initialForm: {},
});

const reducer = combineReducers({
  ads: adsDuck,
  params: paramsDuck,
  ui: uiDuck,
});

reducer.key = STORE_KEY;

export { reducer };
